module.exports = __webpack_public_path__ + "static/media/avatar.ff5e5fd7.svg";